import React from 'react';
import { Label } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import BackButton from '../../../components/custom/BackButton';
import { createdUpdatedInfo, formatDatetime, formatMawb } from '../../../utils';
import ActionIcon from '../../../components/custom/ActionIcon';
import { IRFS } from '../../../globals/interfaces';
import { CounterAwb } from '../../../components/counter/import/useAwbs';
import { RFSData } from '.';
import { Table } from 'reactstrap';

interface Props {
    item: RFSData | undefined;
    modal: boolean;
    setModal: (state: boolean) => void;
}

export default function ModalDetails({
    item,
    modal,
    setModal
}: Props) {

    const toggle = () => setModal(!modal);

    if (!item) {
        return null;
    }

    return (
        <CustomModal isOpen={modal} toggle={toggle} size={'lg'}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>RFS Detail {formatMawb(item.s_mawb)}</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <CustomTable striped>
                    <thead>

                    </thead>
                    <tbody>
                        <tr>
                            <td>Company</td>
                            <td>{item.truckerName}</td>
                        </tr>
                        <tr>
                            <td>Driver</td>
                            <td>{item.driverName}</td>
                        </tr>
                        <tr>
                            <td>Airline Truck Number</td>
                            <td>{item.truckNumber}</td>
                        </tr>
                        <tr>
                            <td>Cargo Handling Type</td>
                            <td>{item.cargoHandlingType}</td>
                        </tr>
                        <tr>
                            <td>Truck Type</td>
                            <td>{item.truckType}</td>
                        </tr>
                        <tr>
                            <td>Vehicle Type</td>
                            <td>{item.vehicleType}</td>
                        </tr>
                        <tr>
                            <td>Origin</td>
                            <td>{item.origin}</td>
                        </tr>
                        <tr>
                            <td>Destination</td>
                            <td>{item.destination}</td>
                        </tr>
                        <tr>
                            <td>Type</td>
                            <td>{item.type}</td>
                        </tr>
                        <tr>
                            <td>Fuel Type</td>
                            <td>{item.fuelType}</td>
                        </tr>
                        <tr>
                            <td>Created</td>
                            <td>
                                <div>{formatDatetime(item.createdAt)}</div>
                            </td>
                        </tr>
                        <tr>
                            <td>Counter Process</td>
                            <td>
                                <div>{item.s_counter_ownership_agent}, {formatDatetime(item.t_counter_ownership)} - {formatDatetime(item.t_counter_end)}</div>
                            </td>
                        </tr>
                        <tr>
                            <td>Dock Process</td>
                            <td>
                                <div>{item.s_dock_ownership}, {formatDatetime(item.t_dock_ownership)} - {formatDatetime(item.t_dock_complete)}</div>
                            </td>
                        </tr>
                        <tr>
                            <td>Status</td>
                            <td>
                                {item.status}
                            </td>
                        </tr>
                    </tbody>
                </CustomTable>
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <Label>
                        {createdUpdatedInfo(item)}
                    </Label>
                </FooterContentContainer>
            </ExpandedFooter>
        </CustomModal>
    );
}

const CustomModal = styled(Modal)`
    width: 900px;
`;

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const CustomTable = styled(Table)`
    /* width: 520px; */
    td {
        text-transform: uppercase;
    }
`;